import type { AutomationCategoryResponse } from '@reach/shared-types/automation-category';
import { Search } from 'lucide-react';
import { EngageStatusFilter } from './engage-library-types';
import { StatusFilterOption } from './engage-library-utils';
import { EngageLibraryCategoryFilter } from './EngageLibraryCategoryFilter';
import { EngageLibraryStatusFilter } from './EngageLibraryStatusFilter';
import styles from './EngageLibraryToolbar.module.css';

interface EngageLibraryToolbarProps {
  search: string;
  onSearchChange: (value: string) => void;
  statusFilter: EngageStatusFilter;
  statusOptions: StatusFilterOption[];
  statusCounts: Record<EngageStatusFilter, number>;
  onStatusFilterChange: (value: EngageStatusFilter) => void;
  /** Empty hides the category filter, as for segments, which have no categories. */
  categories: AutomationCategoryResponse[];
  categoryIds: string[];
  onCategoryIdsChange: (categoryIds: string[]) => void;
}

export function EngageLibraryToolbar({
  search,
  onSearchChange,
  statusFilter,
  statusOptions,
  statusCounts,
  onStatusFilterChange,
  categories,
  categoryIds,
  onCategoryIdsChange,
}: EngageLibraryToolbarProps) {
  const hasCategories = categories.length > 0;

  return (
    <div className={styles.toolbar}>
      <label className={styles.searchField}>
        <Search className={styles.searchIcon} />
        <input
          type="search"
          value={search}
          onChange={event => onSearchChange(event.target.value)}
          placeholder="Search by name…"
          aria-label="Search by name"
        />
      </label>
      <EngageLibraryStatusFilter
        value={statusFilter}
        counts={statusCounts}
        options={statusOptions}
        onChange={onStatusFilterChange}
      />
      {hasCategories && (
        <EngageLibraryCategoryFilter
          categories={categories}
          selectedCategoryIds={categoryIds}
          onChange={onCategoryIdsChange}
        />
      )}
    </div>
  );
}
